import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getToken, removeToken } from '@/utils/auth';
import { AppStore } from '@/store/modules/app';
import qs from 'qs';
import router from '@/router/index';

/**请求拦截白名单 */
const interceptorsWhiteList = [
  '/api/Customer/Account/DownloadTemplate', //生成会员余额导入模板
  '/api/Customer/Account/export', //导出资金账户列表
  '/api/Order/Exprot', //导出资金账户列表
  '/api/Report/RechargeCommission', //销售提成报表
  '/api/Report/OrderCommission', //订单统计列表
  '/api/Report/StockReport' //库存列表
];

/**请求拦截 */
axios.interceptors.request.use(
  (req: AxiosRequestConfig) => {
    if (req.method === 'get') {
      req.params = Object.assign({}, req.params, { t: Date.parse(new Date().toDateString()) / 1000 });
    } else {
      AppStore.SetMask(true);
    }
    trimData(req.params);
    trimData(req.data);
    let token = getToken();
    if (token) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

/**请求结果拦截 */
axios.interceptors.response.use(
  (response: AxiosResponse) => {
    if (response.data instanceof Blob) return response;
    AppStore.SetMask(false);
    if (response.config.url && interceptorsWhiteList.indexOf(response.config.url) != -1) {
      return response;
    }
    if (response && response.status == 200) {
      if (response.data.success) {
        return response.data.result;
      } else {
        const error = response.data.error;
        if (error.validationErrors && error.validationErrors.length > 0) {
          AppStore.ShowError(error.validationErrors[0].message);
        } else {
          AppStore.ShowError(error.message);
        }
        return Promise.reject(response.data);
      }
    }
  },
  (error: any) => {
    if (error.response && error.response.data.error) {
      /**提示错误 */
      const errorDescription = error.response.data.error.message;
      if (errorDescription) {
        AppStore.ShowError(errorDescription);
      } else {
        AppStore.ShowError(error);
      }
      AppStore.SetMask(false);
    }

    if (error && error.response) {
      let logoutFn = () => {
        removeToken();
        router.push('login');
      };
      switch (error.response.status) {
        case 400:
          break;
        case 401:
          logoutFn();
          break;
        case 403:
          logoutFn();
          break;
        default:
          break;
      }
    }

    return Promise.reject(error);
  }
);

/**删除字符串开始和末尾的空格 */
function trimData(data: any) {
  if (typeof data === 'string') {
    // return data.replace(/^[\s　]+|[\s　]+$/g, "").replace(/\ +/g, "");
    return data.trim();
  }
  if (data != undefined) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (typeof data[key] == 'string') {
          data[key] = data[key].trim();
        }
      }
    }
  }
}

/**请求类型 */
export default {
  /**get 请求 */
  get(url: string, params?: any) {
    return axios({
      method: 'get',
      url: url,
      params: params,
      paramsSerializer: params => {
        return qs.stringify(params, {
          arrayFormat: 'repeat'
        });
      }
    });
  },

  /**post 请求 */
  post(url: string, params: any) {
    return axios({
      method: 'post',
      url: url,
      data: params
    });
  },

  /**put 请求 */
  put(url: string, params?: any) {
    return axios({
      method: 'put',
      url: url,
      data: params
    });
  },

  /**del请求 */
  del(url: string, params?: any) {
    return axios({
      method: 'delete',
      url: url,
      data: params
    });
  },

  /**下载文件 */
  download(url: string, params: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        params: Object.assign({}, params, {
          t: Date.parse(new Date().toDateString()) / 1000
        }),
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(params, {
            arrayFormat: 'repeat'
          });
        }
      })
        .then(response => {
          var fileName = response.headers['content-disposition'];
          var regex = /filename=([\s|\S]+);/g;
          var match = regex.exec(fileName);
          if (match) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', decodeURI(match[1]));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            resolve();
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
